<template>
    <div class="input-number-dash">
        <textarea
            inputmode="numeric"
            class="input-number-dash__text"
            :placeholder="generatePlaceHolder()"
            v-model="inputFormatted"
            v-imask="calculateMask()"
            @accept="onAccept"
            @input="onInput"
        ></textarea>
    </div>
</template>

<script>
import Vue from 'vue';
import { IMaskDirective } from 'vue-imask';

export default Vue.extend({
    name: 'InputNumberDash',
    directives: {
        imask: IMaskDirective,
    },
    data() {
        return {
            value: '',
        };
    },
    props: {
        placeholder: {
            type: String,
            required: false,
            default:
                'Cách chơi: \nCác số được cách nhau bởi dấu ‘ - ’. Ví dụ : 01 - 02 - 05 - 62',
        },
        maxNumber: {
            type: Number,
            required: false,
            default: 4,
        },
        lengthNumber: {
            type: Number,
            required: false,
            default: 2,
        },
        mask: {
            type: Object,
            required: false,
            default: () => {
                return {
                    mask: '00-00-00-00',
                    lazy: true,
                };
            },
        },
        inputSelectedValue: {
            type: Array,
        },
    },
    components: {},
    watch: {
        inputSelectedValue: function(val) {
            if (
                this.value === '' ||
                (this.value !== '' &&
                    this.value.split('-')[this.value.split('-').length - 1]
                        .length === this.lengthNumber) ||
                this.value.split('-').length === val.length
            ) {
                this.value =
                    val.length > 0
                        ? val
                              .map(numberInteger => {
                                  let numberString = numberInteger + '';
                                  while (
                                      numberString.length < this.lengthNumber
                                  )
                                      numberString = '0' + numberString;
                                  return numberString;
                              })
                              .join('-')
                        : '';
            }
        },
    },
    methods: {
        onAccept(e) {
            const maskRef = e.detail;
            let currentValue = maskRef.value;
            const lastChar = currentValue.slice(currentValue.length - 1);
            if (lastChar === '-') {
                currentValue = currentValue.slice(0, currentValue.length - 1);
            }
            const nums = currentValue.split('-');
            const uniq = [...new Set(nums)];
            this.value = uniq.join('-');
        },
        onInput() {
            setTimeout(() => {
                let arrayNumberString = this.value.trim().split('-');
                const onErrorChecked = this.onErrorChecked(arrayNumberString);
                if (onErrorChecked) {
                    arrayNumberString = this.value
                        .substring(0, this.value.length - 1)
                        .trim()
                        .split('-');
                }
                if (!this.value) {
                    this.$emit('change', []);
                } else {
                    this.$emit(
                        'change',
                        arrayNumberString
                            .filter(
                                numberString =>
                                    numberString.length === this.lengthNumber,
                            )
                            .map(numberString => +numberString),
                    );
                }
            }, 300);
        },
        calculateMask() {
            this.mask.mask = Array.from({ length: this.maxNumber }, () =>
                Array.from({ length: this.lengthNumber }, () =>
                    (0).toString(),
                ).join(''),
            ).join('-');
            return this.mask;
        },
        onErrorChecked(arrayNumberString) {
            let errorCheck = false;
            if (
                arrayNumberString[arrayNumberString.length - 1].length >
                this.lengthNumber
            ) {
                errorCheck = true;
                this.$swal.fire({
                    title:
                        '<div class="popup__icon popup__icon--limit-number"></div>',
                    html: `<b>Bạn chỉ nhập tối đa ${this.maxNumber} số</b>`,
                    customClass: {
                        popup: 'swal2-popup-warning-custom',
                    },
                    showCloseButton: true,
                });
            }
            return errorCheck;
        },
        generatePlaceHolder() {
            const numberString = Array.from({ length: 4 }, (_, i) =>
                Array.from({ length: this.lengthNumber }, (_, j) =>
                    (i + j).toString(),
                ).join(''),
            ).join('-');
            return (
                'Cách chơi: \nCác số được cách nhau bởi dấu ‘ - ’. Ví dụ : ' +
                numberString
            );
        },
    },
    created() {
        this.value =
            this.inputSelectedValue.length > 0
                ? this.inputSelectedValue
                      .map(numberInteger => {
                          let numberString = numberInteger + '';
                          while (numberString.length < this.lengthNumber)
                              numberString = '0' + numberString;
                          return numberString;
                      })
                      .join('-')
                : '';
    },
    computed: {
        inputFormatted: {
            get() {
                return this.value;
            },
            set(val) {
                let currentValue = val;
                const lastChar = currentValue.slice(currentValue.length - 1);
                if (lastChar === '-') {
                    currentValue = currentValue.slice(
                        0,
                        currentValue.length - 1,
                    );
                }
                const nums = currentValue.split('-');
                const uniq = [...new Set(nums)];
                this.value = uniq.join('-');
            },
        },
    },
});
</script>

<style scoped lang="scss">
@import 'InputNumberDash';
</style>
